/**
 * 获取环境
 * @returns { Object } {
 *  // 是否是线上环境
 *  isProd,
 *  // 测试环境 envId 1 301
 *  envId,
 *  // 测试环境 envType fvt beta
 *  envType,
 *  // 环境值 fvt | 1.fvt | 301.beta, prod 为空
 *  envHostStr
 * }
 */
export function getTujiaHostEnv() {
    var finds = /^https?:\/\/[a-zA-Z]*(([1-9]{0,4}).(fvt|beta|dev))?.tujia.com/.exec(window.location.origin);
    var envHostStr = (finds && finds[1]) || '';
    var envId = (finds && finds[2]) || '';
    var envType = (finds && finds[3]) || '';
    var isProd = envHostStr === '';
    return {
        isProd: isProd,
        envId: envId,
        envType: envType,
        envHostStr: envHostStr
    };
}
/**
 * 获取环境地址
 * @param childHostName:string 子域名
 * @param path:string 路径
 */
export function getHostByEnv(childHostName) {
    var envInfo = getTujiaHostEnv();
    var env = '';
    // 处理测试环境场景 demo: m1.fvt.tujia.com 场景
    if (!envInfo.isProd) {
        env = envInfo.envHostStr;
    }
    return window.location.protocol + "//" + childHostName + env + ".tujia.com";
}
